<ph-field>
    <ph-label>{{ section.label }}</ph-label>
    <ph-select
        [items]="items"
        [value]="value"
        [ariaLabel]="section.label"
        (ph-change)="onSelectionChange($event.detail)">
    </ph-select>
</ph-field>
